import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import {
  CommonResponseModel,
  DriverReq,
  DriverStatus,
  RoleEnum,
  roleReq,
} from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { DriverEntity } from "./driver-entity";
import { DriverDto } from "./driver.dto";
// import dayjs = require("dayjs");
import { PlantsEntity } from "../plants/plants.entity";
import { DriverId } from "./driver-id";
import moment = require("moment");

@Injectable()
export class DriverService {
  constructor(
    @InjectRepository(DriverEntity)
    private driverRepo: Repository<DriverEntity>,
    @InjectRepository(PlantsEntity)
    private plantRepo: Repository<PlantsEntity>
  ) {}

  async createDriver(
    req: DriverReq,
    isUpdate: boolean
  ): Promise<CommonResponseModel> {
    try {
      if (!isUpdate) {
        // console.log(req,'requesttttt')
        const duplicate = await this.driverRepo.find({
          where: { phoneNumber: "91" + req.phoneNumber },
        });
        // console.log(duplicate,'duplicateeee')
        if (duplicate.length > 0) {
          return new CommonResponseModel(
            false,
            0,
            "Driver Phone Number already exists"
          );
        }
      }

      const entity = new DriverEntity();
      // console.log(req, "reqtey");
      entity.id = req.id;
      entity.name = req.name;
      entity.lastName = req.lastName;
      entity.dateOfBirth = req.dateOfBirth;
      entity.profileImage = req.profileImage;
      entity.profileImagePath = req.profileImagePath;
      entity.email = req.email;
      entity.address = req.address;
      entity.state = req.state;
      entity.city = req.city;
      entity.userType = req.userType;
      entity.licenceNumber = req.licenceNumber;
      entity.licenceClass = req.licenceClass;
      entity.licenceState = req.licenceState;
      entity.createdUser = req.userName;
      entity.vendorId = req.vendorId;
      entity.driverType = req.driverType;
      entity.plantId = req.plantId;
      entity.licenceExpirydate = req.licenceExpirydate
        ? moment(req.licenceExpirydate).format("YYYY-MM-DD")
        : undefined;
      // console.log(entity,'entityyyyyy')
      entity.status =
        req.userName === "admin" ? RoleEnum.ADMIN : RoleEnum.VENDOR;
      entity.driverStatus = DriverStatus.NOTOCCUPIED;
      if (isUpdate) {
        if (req.phoneNumber.length === 10) {
          entity.id = req.id;
          entity.phoneNumber = "91" + req.phoneNumber;
          entity.updatedUser = req.updatedUser;
        } else {
          entity.id = req.id;
          entity.phoneNumber = req.phoneNumber;
          entity.updatedUser = req.updatedUser;
        }
      } else {
        entity.phoneNumber = "91" + req.phoneNumber;
        entity.createdUser = req.createdUser;
      }
      const save = await this.driverRepo.save(entity);
      if (save) {
        return new CommonResponseModel(
          true,
          0,
          isUpdate
            ? "Driver Updated Successfully"
            : "Driver Created Successfully"
        );
      } else {
        return new CommonResponseModel(false, 0, "Error Occured");
      }
    } catch (err) {
      throw err;
    }
  }

  async getActiveDriver(): Promise<CommonResponseModel> {
    const data = await this.driverRepo.find({ where: { isActive: true } });
    if (data) {
      return new CommonResponseModel(true, 1, "Data Retrived", data);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrived");
    }
  }

  async getAllDriver(req?: roleReq): Promise<CommonResponseModel> {
    let query = `
       SELECT d.id, d.name AS NAME,
      d.last_name AS lastName, d.date_of_birth AS dateOfBirth, 
      d.profile_image AS profileImage, d.email, d.phone_number AS phoneNumber,
       d.address, d.state, d.city, d.user_type AS userType, 
       d.licence_number AS licenceNumber, d.licence_class AS licenceClass,
        d.licence_state AS licenceState, d.status, d.driver_status AS driverStatus, 
        d.is_active AS isActive, d.version_flag AS versionFlag,d.driver_type,d.vendor_code AS externalRefNo
      FROM driver d `;
    const result = await this.driverRepo.query(query);

    if (result) {
      return new CommonResponseModel(true, 1, "Data Retrieved", result);
    } else {
      return new CommonResponseModel(false, 0, "Data Retrieved");
    }
  }
  async activateOrDeactivateDriver(
    req: DriverDto
  ): Promise<CommonResponseModel> {
    const record = await this.driverRepo.findOne({ where: { id: req.id } });
    await this.driverRepo.update(
      { id: req.id },
      { isActive: !record.isActive }
    );
    const internalMessage: string = !record.isActive
      ? "Activated Sucessfully"
      : "Deactivated Successfully";
    return new CommonResponseModel(true, 6876, internalMessage);
  }

  async updateDriverPath(
    filePath: string,
    filename: string,
    id: number
  ): Promise<CommonResponseModel> {
    // console.log("upload service id---------------", id);
    try {
      let filePathUpdate;
      filePathUpdate = await this.driverRepo.update(
        { id: id },
        { profileImagePath: filePath, profileImage: filename }
      );
      if (filePathUpdate.affected > 0) {
        return new CommonResponseModel(
          true,
          11,
          "uploaded successfully",
          filePath
        );
      } else {
        return new CommonResponseModel(false, 11, "uploaded failed", filePath);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getDriverDetailsById(req: DriverId): Promise<CommonResponseModel> {
    try {
      let data = await this.driverRepo.findOne({ where: { id: req.id } });
      if (data.id > 0) {
        return new CommonResponseModel(true, 1, "Driver retrived", data);
      } else {
        return new CommonResponseModel(false, 0, "No data found", data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getDriversByType(req: any): Promise<CommonResponseModel> {
    try {
      let data;
      if (req.val === "Vendor") {
        data = await this.driverRepo.find({
          relations: ["plantsInfo"],
          where: { driverType: req.val, vendorId: req.vendorId },
          order: { name: "ASC" },
        });
      } else {
        data = await this.driverRepo.find({
          relations: ["plantsInfo"],
          where: { driverType: req.val },
          order: { name: "ASC" },
        });
      }

      if (data.length > 0) {
        return new CommonResponseModel(true, 1, "Driver retrived", data);
      } else {
        return new CommonResponseModel(false, 0, "No data found", data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  // async getDriversByType(req: any): Promise<CommonResponseModel> {
  //   try{
  //     let data
  //     const plantsData = await this.plantRepo.findOne({where:{plantName: req.plant}})
  //     if(req.val === "Vendor"){
  //       data = await this.driverRepo.find({relations:["plantsInfo"],where:{driverType:req.val,vendorId:req.vendorId,plantId:plantsData.plantId},order:{"name":'ASC'}});
  //     }
  //     else{
  //       data = await this.driverRepo.find({relations:["plantsInfo"],where:{driverType:req.val, plantId:plantsData.plantId

  //       },order:{"name":'ASC'}});
  //     }

  //     if(data.length > 0){
  //       return new CommonResponseModel(true, 1, "Driver retrived", data);
  //     }
  //     else{
  //       return new CommonResponseModel(false, 0, "No data found", data);
  //     }
  //   }catch (error) {
  //     console.log(error);
  //   }
  // }

  async getAvailableDrivers(): Promise<CommonResponseModel> {
    try {
      let query = `SELECT dr.id, dr.name AS driverName, dr.driver_type AS driverType
                   FROM driver dr
                   LEFT JOIN vehicle_request vr 
                   ON dr.id = vr.driver_id 
                   AND vr.status = 'VEHICLE ASSIGNED'
                   WHERE vr.driver_id IS NULL; `;
      
      const result = await this.driverRepo.query(query);
      
      const inhouseDrivers = result.filter((driver: any) => driver.driverType === 'In House');
      const vendorDrivers = result.filter((driver: any) => driver.driverType === 'Vendor');
  
      if (result && result.length > 0) {
        return new CommonResponseModel(true, 1, "Data Retrieved", {
          inhouseDrivers,
          vendorDrivers
        });
      } else {
        return new CommonResponseModel(false, 0, "No data found", { inhouseDrivers: [], vendorDrivers: [] });
      }
    } catch (err) {
      console.log(err);
      return new CommonResponseModel(false, 0, "Error fetching data", []);
    }
  }
  

  async getAssignedDriversData(): Promise<CommonResponseModel> {
    try {
      let query = `SELECT vr.vehicle_id AS vehicle_id, vr.driver_id AS driver_id, dr.name AS driverName, vh.vehicle_name AS vehicleName, vh.registration_number AS registrationNumber
                   FROM vehicle_request vr
                   LEFT JOIN driver dr ON dr.id = vr.driver_id
                   LEFT JOIN vehicle vh ON vh.id = vr.vehicle_id
                   WHERE vr.STATUS = 'VEHICLE ASSIGNED'; `;
      const result = await this.driverRepo.query(query);
      if (result) {
        return new CommonResponseModel(true, 1, "Data Retrived", result);
      } else {
        return new CommonResponseModel(false, 0, "No data found", []);
      }
    } catch (err) {
      console.log(err);
    }
  }
}
